module.exports = __webpack_public_path__ + "img/94.709166f8.jpg";